<section id="Prozess" class="s-prozess">
  <div class="w-layout-blockcontainer c-prozess w-container">
    <div class="header-container">
      <p class="heading-style-preheading">Finance Education Plan</p>
      <h2 class="h2-prozess">Verschwiegene Money-Strategien der Milliardäre</h2>
    </div>
    
    <div class="w-layout-hflex d-prozess-content-holder">
      <!-- Progress Bar -->
      <div class="d-prozess-bar-holder">
        <div class="d-prozess-line">
          <div class="d-line_animation" 
               *ngFor="let step of steps; let i = index">
            <div class="d-prozess-line colorized"></div>
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="d-prozess-content">
        <div class="d-prozess-content-block-holder" *ngFor="let step of steps; let i = index">
          <div class="d-prozess-content-block">
            <div class="w-layout-hflex d-prozess-content-wrapper">
              <!-- Text Content -->
              <div class="d-prozess-content-text">
                <div class="w-layout-hflex d-prozess-heading">
                  <h3 class="h3-prozess">{{ step.title }}</h3>
                  <img [src]="step.icon" loading="lazy" alt="" class="i-prozess-icon">
                </div>
                <p>
                  <ng-container *ngFor="let point of step.content.points; let last = last">
                    <strong>{{ point.title }}</strong>
                    {{ point.description }}
                    <br *ngIf="!last"><br *ngIf="!last">
                  </ng-container>
                </p>
              </div>
              
              <!-- Image -->
              <div class="d-prozess-img">
                <img [src]="step.image.url" 
                     loading="lazy" 
                     [sizes]="'(max-width: 767px) 100vw, (max-width: 991px) 728px, 885px'"
                     [srcset]="step.image.srcset"
                     [alt]="step.image.alt" 
                     class="i-prozess-img">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA Section -->
    <div class="cta-holder">
        <app-apply-button [darkCounter]="true"></app-apply-button>
    </div>
  </div>
</section> 